import { memo } from 'react';
import { redirect, useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import MemberRoutes from './MemberRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import config from 'config';

// store
import { useSelector } from 'react-redux';
import { useMenu } from 'hooks/useMenu';
import decodeToken from 'utils/decode-token';
// ==============================|| ROUTING RENDER ||============================== //

const Routes = memo(() => {
    const { isLoggedIn, token, redirectTo } = useSelector((state) => state.auth);
    const isMember = redirectTo === 'Member';
    const isClub = redirectTo === 'Club';
    const loggedInRoutes = isMember ? MemberRoutes() : MainRoutes(isClub);
    const routes = isLoggedIn ? loggedInRoutes : AuthenticationRoutes();
    useMenu();

    return useRoutes(routes, config.basename);
});

export default Routes;
